var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsOrganization(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.34 15.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.76,14.83h3.58v.51H.02v-.51h3.58v-3.7s-.38-.46-.45-.57C.62,6.5,4.19,1.42,8.85,2.44c3.61.79,5.32,4.96,3.36,8.11-.07.11-.45.53-.45.57v3.7ZM11.76,10.23c.86-1.21.97-2.92.45-4.3-1.56-4.11-7.51-4.11-9.07,0-.52,1.38-.42,3.09.45,4.3v-2.81h1.79c.09-.28-.15-.64-.38-.77-.14-.08-.29.02-.46,0-.62-.04-.91-.81-.51-1.28.45-.53,1.34-.21,1.35.48,0,.12-.07.27-.05.35.03.13.5.43.54.58.05.17-.01.44.01.63h.77v-1.02h.51c-.03-.19.04-.46-.01-.63-.02-.05-.5-.53-.53-.54-.1-.02-.34.27-.8.08-1.01-.4-.14-2.04.8-1.31.35.27.2.5.31.76.06.13.74.68.74.74v.89h.51v-1.58s-.3-.1-.43-.36c-.6-1.28,1.69-1.57,1.44-.19-.08.43-.5.51-.5.55v1.58h.51s-.02-.48,0-.59c.03-.17.27-.26.3-.37.02-.08-.05-.23-.05-.35.01-.68.87-1,1.33-.51.43.46.15,1.26-.49,1.3-.17.01-.34-.09-.46,0-.18.12-.12.33-.13.52h2.04v3.83ZM8.7,4.1c0-.14-.12-.26-.26-.26s-.26.12-.26.26.12.26.26.26.26-.12.26-.26ZM6.41,4.61c0-.14-.12-.26-.26-.26s-.26.12-.26.26.12.26.26.26.26-.12.26-.26ZM10.49,5.12c0-.14-.12-.26-.26-.26s-.26.12-.26.26.12.26.26.26.26-.12.26-.26ZM4.87,5.89c0-.14-.12-.26-.26-.26s-.26.12-.26.26.12.26.26.26.26-.12.26-.26ZM11.25,6.91h-4.09v7.92h1.02v-1.28h2.04v1.28h1.02v-7.92ZM6.65,7.93h-2.55v6.89h.51v-1.28h1.53v1.28h.51v-6.89ZM5.12,14.06v.77h.51v-.77h-.51ZM9.72,14.06h-1.02v.77h1.02v-.77Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.64,11.65l.45-.83-.7-.87.36-1.42,1.08-.37v-.98s-1.07-.32-1.07-.32l-.37-1.35c-.03-.34.55-.65.69-.94l-.47-.87c-.3-.05-.94.29-1.17.16-.07-.04-.97-.94-.99-1.01l.19-1.13-.85-.45c-.29.14-.61.72-.94.69l-1.35-.37-.32-1.06h-.98s-.37,1.07-.37,1.07c-.08.05-1.35.36-1.42.36-.27-.03-.6-.59-.87-.7-.05,0-.78.4-.81.44-.16.18.27.96.12,1.21-.04.07-.94.97-1.01.99l-1.13-.19-.44.86c.14.29.71.6.69.94l-.37,1.35-1.06.32v.98s1.07.37,1.07.37l.36,1.42-.7.87.45.83c.3.08.96-.28,1.19-.15.03.02.32.32.33.34l-.33.38c-.08-.06-.14-.19-.26-.2-.21-.02-1.01.3-1.15.23l-.87-1.48c0-.18.72-.73.76-.88.03-.09-.15-.81-.2-.9-.1-.18-.95-.28-1.12-.42-.06-.05-.05-.09-.05-.15-.02-.17-.02-1.55.03-1.61l1.1-.38c.08-.21.32-.8.23-.99-.07-.16-.74-.66-.74-.84.28-.41.5-1.02.8-1.4.04-.06.06-.09.14-.09.26,0,.72.2,1,.23.25.03.58-.47.77-.64l-.24-1.12c0-.06.02-.08.06-.12.09-.08,1.35-.82,1.43-.82.26.06.71.71.88.76.09.03.77-.13.87-.18.21-.11.29-.88.43-1.1.04-.06.04-.07.12-.09.15-.03,1.59-.02,1.66.02l.38,1.1c.21.08.8.32.99.23.16-.07.66-.74.84-.74.41.28,1.02.5,1.4.8.06.04.09.06.09.14,0,.27-.31.95-.22,1.16.02.04.58.6.63.61l1.12-.24c.06,0,.08.02.12.06.08.09.82,1.35.82,1.43-.06.26-.71.71-.76.88-.03.09.15.81.2.9.09.16.88.28,1.08.4.06.04.07.04.09.12.03.15.02,1.59-.02,1.66l-1.1.38c-.08.21-.32.8-.23.99.07.16.74.66.74.84-.28.41-.5,1.02-.8,1.4-.04.06-.06.09-.14.09-.28,0-.82-.27-1.08-.24-.12.01-.16.17-.25.15-.06-.01-.31-.27-.28-.37,0-.03.24-.27.27-.29.24-.14.89.23,1.19.15Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.68,
    y: 12.53,
    width: 3.06,
    height: 0.51
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.68,
    y: 7.42,
    width: 0.51,
    height: 0.51
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.95,
    y: 7.42,
    width: 0.51,
    height: 0.51
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.23,
    y: 7.42,
    width: 0.51,
    height: 0.51
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.68,
    y: 8.44,
    width: 0.51,
    height: 0.51
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.68,
    y: 10.49,
    width: 0.51,
    height: 0.51
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8.95,
    y: 10.49,
    width: 0.51,
    height: 0.51
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 10.23,
    y: 10.49,
    width: 0.51,
    height: 0.51
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 8.95,
    y: 9.46,
    width: 0.51,
    height: 0.51
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 7.68,
    y: 11.51,
    width: 0.51,
    height: 0.51
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 8.95,
    y: 11.51,
    width: 0.51,
    height: 0.51
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 10.23,
    y: 11.51,
    width: 0.51,
    height: 0.51
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 7.68,
    y: 9.46,
    width: 0.51,
    height: 0.51
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 10.23,
    y: 8.44,
    width: 0.51,
    height: 0.51
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 8.95,
    y: 8.44,
    width: 0.51,
    height: 0.51
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 10.23,
    y: 9.46,
    width: 0.51,
    height: 0.51
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 4.61,
    y: 8.44,
    width: 0.51,
    height: 0.51
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 5.63,
    y: 8.44,
    width: 0.51,
    height: 0.51
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 4.61,
    y: 9.72,
    width: 0.51,
    height: 0.51
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 5.63,
    y: 9.72,
    width: 0.51,
    height: 0.51
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 4.61,
    y: 11,
    width: 0.51,
    height: 0.51
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 5.63,
    y: 11,
    width: 0.51,
    height: 0.51
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 4.61,
    y: 12.27,
    width: 0.51,
    height: 0.51
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 5.63,
    y: 12.27,
    width: 0.51,
    height: 0.51
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsOrganization);
export default __webpack_public_path__ + "static/media/Icons_Organization.e2c25ec121412b7461420a74da56fc6a.svg";
export { ForwardRef as ReactComponent };